import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'zaver-zfb-add-button',
  templateUrl: './zfb-add-button.component.html',
  styleUrls: ['./zfb-add-button.component.css'],
})
export class ZfbAddButtonComponent implements OnInit {
  @Input() text: string;

  constructor() {}

  ngOnInit(): void {}
}
